import React , {useState,useEffect} from 'react';
import {useDispatch,useSelector} from 'react-redux'
import { getTourPackages,getTours } from '../../../actions/tourActions';
import {Loader} from 'rsuite'
import TeamsFeed from './ToursCityFeed';
import TourCityForm from './TourCityForm';
import './team.styles.scss'
import isEmpty from '../../../validations/isEmpty';

// teamReducer
function TrekRegion() {
    const [ editData,setEditData ] = useState({});

    const dispatch = useDispatch();
    const { tourPackages,tourPackageLoading } = useSelector(state => state.tourReducer);

    useEffect(()=>{
        dispatch(getTours());
        dispatch(getTourPackages());
    },[]);

    const onEdit = (data) => {
        setEditData(data)
    }

    let teamsContent;
    if(tourPackageLoading){
        teamsContent = <Loader />
    }else{
        teamsContent =tourPackages && <TeamsFeed 
                                    onEdit = {onEdit}
                                    trekRegions={tourPackages} />;
    }
    return (
        <div className="treks">
            <div className="treks-list">
                {teamsContent}
            </div>
            <div className="treks-form">
                <TourCityForm 
                    onEdit={onEdit}
                    editData={editData}
                    isEdit={!isEmpty(editData)}
                />
            </div>
        </div>
    )
}

export default TrekRegion;